<ion-grid fixed>
  <ion-row>
    @if(alert.iconUrl){
    <ion-col size="12">
      <ion-img [src]="alert.iconUrl"></ion-img>
    </ion-col>
    }
    <ion-col size="12">
      <h2 class="ion-text-center">
        <strong>
          {{ alert.title }}
        </strong>
      </h2>

      <p class="ion-text-center">{{ alert.message }}</p>
    </ion-col>
    @for(b of alert.buttons; track $index;) {
    <ion-col size="6" offset="3">
      <ion-button (click)="itemClick(b)" expand="block" shape="round">
        {{ b.text }}
      </ion-button>
    </ion-col>
    }
  </ion-row>
</ion-grid>
<ion-fab vertical="top" horizontal="start" slot="fixed">
  <ion-fab-button size="small" color="light" fill="outline" (click)="close()">
    <ion-icon name="arrow-back"></ion-icon>
  </ion-fab-button>
</ion-fab>
